$(document).ready(function () {
    openTab(location.hash);
});

$(document).on('click', '.js-scrollTab', function(e) {
    e.preventDefault();

    let $self = $(this);
    openTab($self.data('tab'));
});


$(document).on('click', '.js-scrollBlock', function(e) {
    e.preventDefault();

    scrollWindows($('.' + $(this).data('scroll-block')));
})

const scrollWindows = ($block) => {
    $('html, body').animate({
        scrollTop: $block.offset().top - $('.headerTop').height() - 30
    }, 300, 'linear');
};

const openTab = (scrollTab) => {
    if (scrollTab != "") {
        if ($(`.js-tabs-tab[data-id="${scrollTab}"]`).length > 0) {
            $(`.js-tabs-tab`).removeClass('current');
            $(`.js-tabs-btn`).removeClass('current');
            $(`.js-tabs-tab[data-id="${scrollTab}"]`).addClass('current');
            $(`.js-tabs-btn[data-id="${scrollTab}"]`).addClass('current');
        }
        
        scrollWindows($('.js-tabs'));
    }
};

$(document).on('click', '.js-product__buy', function() {
    var $this = $(this);
    var $message = $this.next('.js-product__blockMessageWrapper');

    if (!$this.hasClass('to-cart')) {
        $message.show();
        setTimeout(function() {
            $message.hide() 
        }, 2000); 
    }
});